export const getSignalRBaseURL = (): string => {
  const protocol = window.__env?.USE_LOCAL ? 'http://' : 'https://'

  const apiEndpointPort = window.__env?.SIGNALR_PORT
    ? `:${window.__env?.SIGNALR_PORT}`
    : ''

  const host = window.__env?.USE_LOCAL
    ? 'berkshire.local'
    : window.__env?.API_HOSTNAME
  return `${protocol}${host}${apiEndpointPort}`
}

export const getSubdomain = () => {
  const host = window.location.host
  const hostPieces = host.split('.')
  const potentialSubdomain = hostPieces[0]

  const onDefaultHost = window.location.hostname === window.__env?.FE_HOSTNAME

  const noSubdomain = hostPieces.length === 1 || onDefaultHost
  return noSubdomain ? '' : potentialSubdomain
}

export const getApiEndpoint = (port = window.__env?.BE_PORT ?? '') => {
  const apiNeedsPort = () => {
    return (
      window.__env?.BE_PORT ||
      (window.__env?.PROMOTION_LEVEL === 'development' &&
        !window.__env?.USE_LOCAL)
    )
  }
  const getApiEndpointSubdomain = () => {
    const appSubdomain = getSubdomain()
    if (appSubdomain) {
      return `${appSubdomain}.`
    }
    return ''
  }

  const protocol = window.__env?.USE_LOCAL ? 'http://' : 'https://'

  const apiHostname = window.__env?.USE_LOCAL
    ? window.__env?.LOCAL_API_HOSTNAME
    : window.__env?.API_HOSTNAME

  const apiEndpointPort = apiNeedsPort() && port ? `:${port}` : ''

  return `${protocol}${getApiEndpointSubdomain()}${apiHostname}${apiEndpointPort}`
}
